import React from 'react';
import Modal from './ui/Modal.jsx';

const ConfirmModal = ({ message, onClose, onConfirm, onCancel, autoCloseOnConfirm = true, title = 'Confirm Action' }) => {
    return (
        <Modal title={title} onClose={onClose} size="md" footer={null}>
            <p className="text-sm text-slate-400">{message}</p>
            <div className="mt-4 flex justify-end gap-2">
                <button type="button" onClick={onCancel || onClose} className="inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm text-slate-200 bg-slate-800/70 hover:bg-slate-800 ring-1 ring-white/10">Cancel</button>
                <button type="button" onClick={() => { try { onConfirm && onConfirm(); } finally { if (autoCloseOnConfirm && onClose) onClose(); } }} className="inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm text-rose-50 bg-rose-600/90 hover:bg-rose-600">Confirm</button>
            </div>
        </Modal>
    );
};

export default ConfirmModal;


